export default {
    version: "274",
    buildNumber: "340",
    baseUrl: "https://cf-st.sc-cdn.net/d/dmX5inTqkgLheUDz1qKix?go=IgsKCTIBBEgBUFxgAQ%3D%3D&uc=92",
};
